import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Context from "bodycodi/cmap/app/components/common/context";
import Login from "bodycodi/cmap/app/components/cmap1010/login";
import Home from "bodycodi/cmap/app/components/cmap2010/home";
import GcldSucces from "bodycodi/cmap/app/components/gcld/gcldSucces";

import "bodycodi/cmap/app/css/cmap1010/cmap1010.css";
import "bodycodi/cmap/app/css/cmap2010/cmap2010.css";
import "bodycodi/cmap/app/css/cmap2020/cmap2020.css";
import "bodycodi/cmap/app/css/cmap2040/cmap2040.css";
import "bodycodi/cmap/app/css/cmap3010/cmap3010.css";
import "bodycodi/cmap/app/css/cmap3020/cmap3020.css";
import "bodycodi/cmap/app/css/cmap3030/cmap3030.css";
import "bodycodi/cmap/app/css/cmap5010/cmap5010.css";
import "bodycodi/cmap/app/css/reset.css";
import "bodycodi/cmap/app/css/common.css";
import "bodycodi/cmap/app/css/common/toast.css";
import "bodycodi/cmap/app/css/common/centerChoosePop.css";
import "bodycodi/cmap/app/css/common/calendar.css";
import "bodycodi/cmap/app/css/common/timePicker.css";
import "swiper/swiper.scss";
import "bodycodi/cmap/app/css/cmap4010/cmap4010.css";
import "bodycodi/cmap/app/css/common/imageEditor.css";
import "bodycodi/cmap/app/css/gcld/gcld.css";
import "bodycodi/cmap/app/css/terms/terms.css";
import "bodycodi/cmap/app/css/common/picker.css";
import "bodycodi/cmap/app/css/store/store.css";

function App() {
  return (
    <Context>
      <Router>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/home" component={Home} />
          <Route path="/gcldSucces" component={GcldSucces} />
        </Switch>
      </Router>
    </Context>
  );
}

export default App;
